export default __webpack_public_path__ + "static/media/zip.c6a15029.svg";